export default __webpack_public_path__ + "maps-guides-styles-layers-fill-extrusion-layer-960-73fc04a94a7a852aa3b730a4a21dbdb3.webp";